import pnlogo from "../../../assets/images/PN - Logo Animation.json";
import Animation from "../lottie";

const DotLoader = () => {
  return (
    <div className="loader-container">
      <div className="dot" />
    </div>
    // <Animation animation={pnlogo} />
  );
};

export default DotLoader;
